module.exports = __webpack_public_path__ + "static/img/LU@2x.96237f59.jpg";